import type { MiddlewareAPI } from 'redux';
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import type { MiddlewareManager } from '@makemydeal/activities-request-proposal';
import { configureRequestProposal } from './config';

export let cachedRequestProposalMiddlewareMgr: MiddlewareManager | undefined;

// needed for testing
export const requestProposalMiddlewareClearCache = () => (cachedRequestProposalMiddlewareMgr = undefined);

export const requestProposalMiddleware = (store: MiddlewareAPI) => (next: any) => (action: AnyFSA) => {
    if (action.type === bootstrapActionTypes.BOOTSTRAP_SUCCESS) {
        cachedRequestProposalMiddlewareMgr = configureRequestProposal();
    }
    if (cachedRequestProposalMiddlewareMgr) {
        cachedRequestProposalMiddlewareMgr.middleware(store)(next)(action);
    } else {
        next(action);
    }
};
